<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2">
      <!-- Class Filter -->
      <div class="col-6 col-md-3 col-lg-2">
      <select
  class="form-select form-select-sm"
  v-model="localFilters.class_id"
  @change="applyFilters"
>
  <option disabled value="">
    {{ $t('filters.allClasses') }}
  </option>
  <option
    v-for="classItem in classes"
    :key="classItem.id"
    :value="classItem.id"
  >
    {{ classItem.name }}
  </option>
</select>

      </div>

      <!-- Reset Filter (desktop) -->
      <div class="col-md-1 d-none d-md-block">
        <button 
          class="btn btn-outline-secondary btn-sm w-100" 
          @click="resetFilters"
          :title="$t('filters.resetTitle')"
        >
          <i class="fas fa-filter-circle-xmark"></i>
        </button>
      </div>  

      <!-- Search -->
      <div class="col-6 col-sm-6 col-md-4 col-lg-6 position-relative">
        <input
          type="text"
          class="form-control form-control-sm ps-5"
          :placeholder="$t('filters.classSearchPlaceholder')"
          v-model="localFilters.search"
          @input="handleSearchInput"
          style="padding-right: 12px"
        />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>

      <!-- Reset Filter (mobile) -->
      <div class="col-6 d-md-none">
        <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters">
          <i class="fas fa-filter-circle-xmark"></i> {{ $t('filters.reset') }}
        </button>
      </div>

      <!-- Add Subject -->
      <div class="col-6 col-md-4 col-lg-3">
        <button 
          class="btn btn-secondary btn-sm w-100" 
          @click="$emit('add')"
          v-can="'subjects.create'"
        >
          <i class="fas fa-plus"></i>
          {{ $t('subjects.addSubject') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, onUnmounted } from 'vue';

const props = defineProps({
  filters: {
    type: Object,
    required: true,
    default: () => ({
      search: '',
      class_id: null
    })
  },
  classes: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update:filters', 'apply-filters', 'reset-filters', 'add']);

const localFilters = ref({
  ...JSON.parse(JSON.stringify(props.filters)),
  class_id: ""  
});
let debounceTimeout = null;

const debounce = (fn, delay) => {
  return (...args) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    
    debounceTimeout = setTimeout(() => {
      fn(...args);
      debounceTimeout = null;
    }, delay);
  };
};

onUnmounted(() => {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }
});

const debouncedSearch = debounce(() => {
  applyFilters();
}, 500);

const handleSearchInput = () => {
  debouncedSearch();
};

const applyFilters = () => {
  emit('update:filters', { ...localFilters.value });
  emit('apply-filters');
};

const resetFilters = () => {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
    debounceTimeout = null;
  }
  
  localFilters.value = {
    search: '',
    class_id: null
  };
  emit('update:filters', localFilters.value);
  emit('reset-filters');
};

watch(() => props.filters, (newVal) => {
  localFilters.value = JSON.parse(JSON.stringify(newVal));
}, { deep: true });
</script>
